import { useEffect, useRef } from 'react';
import { useMutation } from '@apollo/client';
import ADD_NEW_USER from '../graphql/ADD_NEW_USER';
import firePixelBlueKeel from '../pixels/bluekeelPixel';

const useInsertNewUser = (tracking) => {
    const hasFired = useRef(false);
    const clickId = tracking?.HSID ?? 0;

    const [ addNewUser ] = useMutation(ADD_NEW_USER, { 
        onCompleted: (data) => console.log(data.addNewUser.message)
    });

	const createNewUser = async() => {
        addNewUser({ 
            variables: { 
                visitor: {
                    clickId: Number(tracking.HSID),
                    ip_address: tracking?.ip,
                    program: {
                        pid: Number(tracking?.PID),
                        oid: Number(tracking?.OID),
                        eid: tracking?.EID,
                        sid: Number(tracking?.SID),
                        uid: tracking?.UID
                    }
                } 
            } 
        });

        if([5102, 9113, 9371, 9419].includes(Number(tracking.SID))) {
            firePixelBlueKeel(tracking.HSID);
        }
	};

	useEffect(() => {
        if (clickId !== 0 && !hasFired.current) {
            createNewUser();
            hasFired.current = true;
        };
        return () => hasFired.current = false;
		// eslint-disable-next-line
	}, [clickId]);

	return;
};

export default useInsertNewUser;